module.exports = __webpack_public_path__ + "img/chevron-down.db7f1291.svg";